import React, { useState, useEffect } from "react";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import axios from "axios";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import { Link } from "react-router-dom";
import "./agents/Data.css";
import "../../node_modules/react-bootstrap-table/dist/react-bootstrap-table-all.min.css";
import "./PlayerList.css";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const useStyles = makeStyles({
  root: {
    width: "100%",
    overflowX: "auto",
  },
  table: {
    minWidth: 650,
  },
  tableHead: {
    background: "#3f51b5",
    cursor: "pointer",
    "&:hover": {
      backgroundColor: "darkcyan !important",
    },
  },
  tableRow: {
    "&:hover": {
      backgroundColor: "lightgrey !important",
    },
  },
  headerCell: {
    color: "white",
  },
});

export default function Data(props) {
  const [renderShowsTotal, setRenderShowsTotal] = useState(true);
  const [players, setPlayers] = useState([]);
  const [showInfo, setShowInfo] = useState(true); // Añadimos el estado showInfo
  const classes = useStyles();
  const history = useHistory();
  const [selectedIds, setSelectedIds] = useState([]);


  const handleSelect = (row, isSelected) => {
    setSelectedIds(prev => {
      if (isSelected) return [...prev, row.idPlayer];
      return prev.filter(id => id !== row.idPlayer);
    });
  };

  const handleSelectAll = (isSelected, rows) => {
    if (isSelected) {
      setSelectedIds(rows.map(r => r.idPlayer));
    } else {
      setSelectedIds([]);
    }
  };

  const sendAllPlayers = () => {
    if (!players?.length) return;
    const ids = Array.from(new Set(players.map(p => p.idPlayer)));
    console.log(ids)
    history.push({
      pathname: "/updatePlayers",
      state: { ids: ids, AgentName: props.AgentName },
    });
  }

  useEffect(() => {
    const getPlayers = async () => {
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_API2_URL}/Agent/Agent_GetPlayersList`,
          {
            prmIdAgent: props.IdAgent,
            prmDecimals: 0,
            prmTrunc: 1,
            prmIdCurrency: props.IdCurrency,
          }
        );

        setPlayers(Array.isArray(response.data) ? response.data : []);

      } catch (error) {
        console.error("Error loading players:", error);
        setPlayers([]);
      }
    };

    if (props.IdAgent) {
      getPlayers();
    }

  }, [props.IdAgent, props.IdCurrency]);

  const moveFormatter = (cell) => {
    if (cell === true) {
      return <i className="text-green-500 fa fa-check"></i>;
    } else if (cell === false) {
      return <i className="text-red-500 fa fa-times"></i>;
    }
    return null;
  };

  function onAfterDeleteRow(rowKeys) {
    alert("The rowkey you drop: " + rowKeys);
  }

  function customConfirm(next, dropRowKeys) {
    const dropRowKeysStr = dropRowKeys.join(",");
    if (
      window.confirm(
        `(It's a custom confirm)Are you sure you want to delete ${dropRowKeysStr}?`
      )
    ) {
      next();
    }
  }

  const options = {
    page: 1,
    sizePerPageList: [
      { text: "15", value: 15 },
      { text: "50", value: 50 },
      { text: "500", value: 500 },
      { text: "1000", value: 1000 },
    ],
    sizePerPage: 10,
    pageStartIndex: 1,
    paginationSize: 3,
    prePage: "Prev",
    nextPage: "Next",
    firstPage: "First",
    lastPage: "Last",
    paginationShowsTotal: renderShowsTotal,
    paginationPosition: "bottom",
    afterDeleteRow: onAfterDeleteRow,
    handleConfirmDeleteRow: customConfirm,
    onSelect: (row, isSelect) => handleSelect(row, isSelect),
    onSelectAll: (isSelect, rows) => handleSelectAll(isSelect, rows),
  };

  const selectRowProp = {
    mode: "checkbox",
    clickToSelect: true,
    clickToExpand: true,
    onSelect: handleSelect,
    onSelectAll: handleSelectAll
  };

  const urlFormatter = (cell, row) => {
    return <Link to={`/player/${row.idPlayer}`}>{cell}</Link>;
  };

  const goToBulk = () => {
    if (!selectedIds.length) return;

    history.push({
      pathname: "/updatePlayers",
      state: { ids: selectedIds, AgentName: props.AgentName },
    });
  };

  return (
    <Paper className={classes.root}>
      <div className="flex justify-between gap-2 mt-4 mb-2">
        <h2>Players</h2>
        <div className="flex gap-2">
          <button className="bg-[#3F51B5] text-white w-fit uppercase hover:opacity-80 transition-all p-2 rounded-sm font-semibold text-sm disabled:bg-gray-500 disabled:opacity-35" onClick={sendAllPlayers} title="updatePlayers">
            <span >Edit All</span>
          </button>
          <button className="bg-[#3F51B5] text-white w-fit uppercase hover:opacity-80 transition-all p-2 rounded-sm font-semibold text-sm disabled:bg-gray-500 disabled:opacity-35" onClick={goToBulk} title="updatePlayers" disabled={!selectedIds.length}>
            <span>Edit Selected</span>
          </button>
        </div>
      </div>
      <Table className={classes.table} aria-label="simple table">
        <TableBody className={showInfo ? "show-table" : "hide-table"}>
          {players.length > 0 && (
            <div>
              <BootstrapTable
                pagination
                options={options}
                selectRow={selectRowProp}
                version="4"
                data={players}
                hover
              >
                <TableHeaderColumn dataField="idPlayer" isKey hidden>
                  Field A
                </TableHeaderColumn>
                <TableHeaderColumn dataField="player" dataFormat={urlFormatter}>
                  Player
                </TableHeaderColumn>
                <TableHeaderColumn dataField="name">Name</TableHeaderColumn>
                <TableHeaderColumn dataField="currency">Currency</TableHeaderColumn>
                <TableHeaderColumn dataField="creditLimit">CreditLimit</TableHeaderColumn>
                <TableHeaderColumn dataField="balance">Balance</TableHeaderColumn>
                <TableHeaderColumn dataField="lifeTimeNet">Life Time Net</TableHeaderColumn>
                <TableHeaderColumn dataField="lastWager">LastWager</TableHeaderColumn>
                <TableHeaderColumn
                  dataField="status"
                  dataAlign="center"
                  dataFormat={moveFormatter}
                  editable={{ type: "checkbox", options: { values: "true:false" } }}
                >
                  Status
                </TableHeaderColumn>
                <TableHeaderColumn
                  dataField="enableSports"
                  dataAlign="center"
                  dataFormat={moveFormatter}
                  editable={{ type: "checkbox", options: { values: "true:false" } }}
                >
                  Sports
                </TableHeaderColumn>
                <TableHeaderColumn
                  dataField="enableCasino"
                  dataAlign="center"
                  dataFormat={moveFormatter}
                  editable={{ type: "checkbox", options: { values: "true:false" } }}
                >
                  Casino
                </TableHeaderColumn>
                <TableHeaderColumn
                  dataField="enableHorses"
                  dataAlign="center"
                  dataFormat={moveFormatter}
                  editable={{ type: "checkbox", options: { values: "true:false" } }}
                >
                  Horses
                </TableHeaderColumn>
              </BootstrapTable>
            </div>
          )}
        </TableBody>
      </Table>

    </Paper>
  );
}
